import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const UploadIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 14"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M14.667 7.875h-4V7h1.777c1.184 0 1.784-1.414.942-2.24L8.942.387a1.349 1.349 0 0 0-1.886 0L2.61 4.76C1.775 5.584 2.37 7 3.556 7h1.777v.874h-4C.597 7.875 0 8.463 0 9.188v3.5C0 13.412.597 14 1.333 14h13.334c.736 0 1.333-.588 1.333-1.312v-3.5c0-.725-.597-1.313-1.333-1.313ZM3.556 5.688 8 1.313l4.444 4.375h-3.11v4.375H6.666V5.688H3.556Zm11.11 7H1.334v-3.5h4v.875c0 .724.598 1.312 1.334 1.312h2.666c.736 0 1.334-.588 1.334-1.312v-.875h4v3.5Zm-1.11-1.75a.66.66 0 0 1-.667.656.66.66 0 0 1-.667-.656.66.66 0 0 1 .667-.657.66.66 0 0 1 .667.657Z"/>
    </svg>
);
UploadIcon.displayName = 'UploadIcon';
export default UploadIcon;
